module.exports = __webpack_public_path__ + "img/lunbo.cd746118.png";